import React from 'react';
import Link from 'next/link';

const OfferForTheMachineYouAreLookingFor = () => {
  return (
    <div className="row mb-30 align-items-center">
      <div className="col col-xl-10">
        <h2 className="h5">Aradığınız İş Makinasına İstediğiniz Teklifi Verin</h2>
      </div>
      <div className="col col-xl-5 text-right">
        <Link href="/machinery">
          <a className="im-button im-button--primary text-center">Satıştaki Makinaları İncele</a>
        </Link>
      </div>
    </div>
  );
};

export default OfferForTheMachineYouAreLookingFor;
